import { Controller } from '@hotwired/stimulus';

// One dialog for the whole list: which brand is being deleted, and whether it can be, are
// answered when the row is clicked rather than rendered N times over.
//
// Confirming submits that row's own delete form by name, so the request is an ordinary
// Turbo form rather than one assembled here.
export default class extends Controller {
  static targets = ['message', 'confirm'];

  static outlets = ['dialog-component'];

  ask(event) {
    event.preventDefault();
    const row = event.currentTarget;
    const name = row.dataset.brandName;
    const inUse = parseInt(row.dataset.inUseCount, 10) || 0;

    this.title = `Delete ${name}?`;
    this.messageTarget.textContent = inUse > 0
      ? `${name} is used by ${inUse} ${inUse === 1 ? 'job' : 'jobs'}. ` +
        'Remove the brand from those jobs before deleting it.'
      : "You won't be able to post jobs under this brand anymore. This can't be undone.";

    this.confirmTarget.disabled = inUse > 0;
    this.confirmTarget.setAttribute('form', row.dataset.formId);
    this.dialogComponentOutlet.open();
  }

  set title(text) {
    const heading = this.dialogComponentOutletElement.querySelector('.ui-dialog__title');
    if (heading) heading.textContent = text;
  }

  // The confirm button submits the form itself; this only takes the dialog out of the way.
  destroy() {
    this.dialogComponentOutlet.close();
  }
}
